export default {
  inject: {
    elFormItem: {
      default: function _default() {
        return {
          onFieldChange: function onFieldChange() {}
        };
      }
    }
  },
  methods: {
    fieldChange: function fieldChange() {
      this.elFormItem.onFieldChange();
    }
  }
};